import { joinCn } from '@/component/UI/util';

export enum PAGE_BUTTON_STATE {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  DEFAULT = 'default',
}

export enum PREV_NEXT_BUTTON_STATE {
  ACTIVE = 'active',
  DISABLED = 'disabled',
}

export const TW_PAGE_BUTTON_PRESET_BASE = joinCn(
  'h-8 min-w-8 px-2 rounded-full',
  'flex items-center justify-center hover:shadow-sm',
  'text-body-l leading-normal',
  'hover:cursor-pointer',
);

export const TW_PAGE_BUTTON_PRESET_STATE = {
  [PAGE_BUTTON_STATE.ACTIVE]: joinCn('bg-primary-500 bg-white font-bold'),
  [PAGE_BUTTON_STATE.DISABLED]: joinCn('bg-white font-normal text-gray-400'),
  [PAGE_BUTTON_STATE.DEFAULT]: joinCn('bg-white font-normal text-black'),
};

export const TW_CONTROL_BUTTON_CONTAINER = joinCn(
  'flex items-center justify-center gap-2 px-3 py-2',
);

export const style = {
  vPagination: joinCn('flex items-center gap-2'),
  VPaginationControlContainer: joinCn(TW_CONTROL_BUTTON_CONTAINER),
  VPaginationControlButton: joinCn(
    'h-4 w-4',
    'cursor-pointer text-black',
    'aria-disabled:!cursor-not-allowed aria-disabled:text-gray-400',
  ),
  VPaginationPageButton(state: PAGE_BUTTON_STATE) {
    return joinCn(
      TW_PAGE_BUTTON_PRESET_BASE,
      TW_PAGE_BUTTON_PRESET_STATE[state],
    );
  },
};
